// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__M2MUH","inputDescription":"styles_inputDescription__1Kar-"};